<div class="mat-elevation-z8 py-2 overflow-auto scroll-div" style="overflow: auto;">
  <ng-content></ng-content>


  @if (metadata.dataSource && metadata.dataSource.data.length > 0) {
    <mat-paginator [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize"
      (page)="pageChange.emit($event)"
      [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons [attr.aria-label]="">
    </mat-paginator>
  }

  <!--No Data Container-->
  @if ((!metadata.dataSource || !metadata.dataSource.data || (metadata.dataSource.data.length==0)) && !!metadata.isLoaded) {
    <app-no-record-container
      message="{{ 'messages.no_data_found' | translate }}">
    </app-no-record-container>
  }

</div>

<!-- <div class="mat-elevation-z8 py-2"> -->

<!-- <table mat-table class="uw-table" multiTemplateDataRows [dataSource]="dataSource" matSort
(matSortChange)="sortChange.emit($event)">


<ng-content select="[UwTableColumnDefinition]"></ng-content> -->

<!-- -Action Column
<ng-container matColumnDef="action">
  <th mat-header-cell *matHeaderCellDef class="uw-table-action-buttons">
  </th>
  <td mat-cell *matCellDef="let element">

    <button class="ml-3" mat-icon-button [matMenuTriggerFor]="menu" [attr.aria-label]="'Row actions' | translate">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <ng-content select="[slot='UwTableRowActions']"></ng-content>
    </mat-menu>

  </td>
</ng-container>

Expand Column
<ng-container matColumnDef="expand">
  <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'Expand Row' | translate" class="uw-table-action-buttons"></th>
  <td mat-cell *matCellDef="let element">

    <div class="d-flex align-items-center" style="gap: 10px;">

      <button mat-icon-button aria-label="expand row" (click)="onRowExpand(element, $event)">
        <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
        <mat-icon *ngIf="expandedElement != element">keyboard_arrow_down</mat-icon>
      </button>
    </div>

  </td>
</ng-container>

Expanded Content Column - The detail row is made up of this one column that spans across all columns --
<ng-container matColumnDef="expandedDetail">
  <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
    <div class="uw-table-child-expanded-row-detail-container" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">

      <div *ngIf="element == expandedElement" class="my-3 w-100">
        <ng-content select="[slot='expandedRowDetailContent']"></ng-content>
      </div>
    </div>
  </td>
</ng-container> !-->

<!-- <tr mat-header-row class="align-left" *matHeaderRowDef="displayedColumnsX"></tr>
<tr mat-row *matRowDef="let element; columns: displayedColumnsX;" class="uw-table-parent-row"
[class.uw-table-parent-expanded-row]="expandedElement === element"></tr> -->
<!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="uw-table-child-row"></tr> -->

<!-- </table>   -->

<!--
<mat-paginator [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize"
  *ngIf="dataSource && dataSource?.data?.length! > 0" (page)="pageChange.emit($event)"
  [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons [attr.aria-label]="">
</mat-paginator> -->

<!-- </div> -->